// extracted by mini-css-extract-plugin
export default {"multiline-text":"merge-subscriber-group-modal__multiline-text--nzZio","multilineText":"merge-subscriber-group-modal__multiline-text--nzZio"};